/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Billing_Free_UpgradeInputs */



/**
* | output |
* | --- |
* | "Upgrade for paid models →" |
*
* @param {Dashboard_Billing_Free_UpgradeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_free_upgrade = /** @type {((inputs?: Dashboard_Billing_Free_UpgradeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Free_UpgradeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Upgrade für kostenpflichtige Modelle →")
	return /** @type {LocalizedString} */ ("Upgrade for paid models →")
});